module.exports = __webpack_public_path__ + "img/image8.27c56c32.jpeg";